import Contacts from "./Container"

export default Contacts
